import Api from './api';

const CartaServicoService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/cartaservico/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/cartaservico/buscar?${params}`)
        return response
    }
}

export default CartaServicoService;